import React from "react"
import { ImageProps } from "../../micro-component/Image/Image.types"

type OptionalAltImageProps = Omit<ImageProps, "alt"> & {
  alt?: string
  src: string | { src: string } | undefined
}

function SvgImg(props: OptionalAltImageProps) {
  //src is an svg
  const src = props.src
  if (!src) {
    return null
    //@ts-expect-error src can be undefined
  } else if (src?.src) {
    //@ts-expect-error src can be undefined
    return <img {...props} src={src.src} />
  } else {
    return <img {...props} src={src} />
  }
}

export default SvgImg
